import React, { useState } from "react";

import { Modal } from "reactstrap";

import img1 from "styles/common/img/common/picon1.png";
import ExchangeDone from "components/starshop/exchangeModal/ExchangeDone";

const ExchangeBtn = (props) => {
    const { checked, disabled, phoneNumber, myInfo, targetCode, exchangable } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const [disabledNum, setDisabledNum] = useState(false);

    const regExp = /^01([1|0|]?)$/;

    const handleExchange = () => {
        if (!regExp.test(phoneNumber.arr1) || phoneNumber.arr2.length < 4 || phoneNumber.arr3.length < 4) {
            setDisabledNum(true);
        }

        console.log("exchangable", exchangable);
        setModalOpen(!modalOpen);
    };

    //발송이 불가한 번호일떄
    const handleState = () => {
        //setModalOpen(!modalOpen)
        // setDisabledNum(false);
        //window.scrollTo(0,0);
        window.location.reload();
        window.scrollTo(0, 0);
    };

    return (
        <div className="star_btn_bottom">
            {checked && disabled ? (
                <button type="button" onClick={handleExchange}>
                    선물 교환하기
                </button>
            ) : (
                <button className="disabled-btn" type="button">
                    선물 교환하기
                </button>
            )}
            <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen} className="popopWrap2">
                <div className="pop_icon">
                    <img src={img1} />
                </div>
                <div className="pop_tit"></div>
                {!disabledNum && exchangable ? (
                    <div>
                        <div className="pop_tit"></div>
                        <div className="pop_txt">
                            <p className="">
                                발송된 선물은 취소가 불가합니다.
                                <br />
                                번호를 정확하게 입력하셨나요?
                            </p>
                        </div>
                        <div className="pop_btn2 clear">
                            <button
                                type="button"
                                className="newbtn newbtn__txt"
                                onClick={() => setModalOpen(!modalOpen)}
                            >
                                취소
                            </button>
                            <ExchangeDone phoneNumber={phoneNumber} myInfo={myInfo} targetCode={targetCode} />
                        </div>
                    </div>
                ) : !exchangable ? (
                    <div>
                        <div className="pop_txt">
                            <p className="">선물 교환 가능 회원이 아닙니다.</p>
                        </div>
                        <div className="pop_btn2 clear">
                            <button type="button" className="new2btn newbtn__txt newbtn__one" onClick={handleState}>
                                확인
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="pop_txt">
                            <p className="">
                                선물 발송이 불가한 번호입니다.
                                <br />
                                다시 확인 해주세요.
                            </p>
                        </div>
                        <div className="pop_btn2 clear">
                            <button type="button" className="new2btn newbtn__txt newbtn__one" onClick={handleState}>
                                확인
                            </button>
                        </div>
                    </div>
                )}

                {/* <div className="modal-footer">
          <div type="button" className="white-btn dp_inb" onClick={() => setModalOpen(!modalOpen)}>취소</div>
          <ExchangeDone phoneNumber={phoneNumber} myInfo={myInfo} targetCode={targetCode}/>
        </div> */}
            </Modal>
        </div>
    );
};

export default ExchangeBtn;
